import { render, staticRenderFns } from "./memopelunasanblacklistfrm.vue?vue&type=template&id=4238f856&"
import script from "./memopelunasanblacklistfrm.vue?vue&type=script&lang=js&"
export * from "./memopelunasanblacklistfrm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports